var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',_vm._b({staticClass:"add-btn",attrs:{"flat":""},on:{"click":function (event) { return _vm.$emit('click', event); }}},'q-btn',_vm.$attrs,false),[_c('i',{staticClass:"fa fa-plus icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }